<div class="login-page">
  <!-- Seção principal com fundo azul -->
  <section class="hero-section">
    <!-- Header -->
    <header class="header">
      <img src="/imgs/ms_logo.png" alt="MAIS MÉDICOS" class="logo-img" />
    </header>

    <!-- Conteúdo central -->
    <div class="main-content">
      <!-- Lado esquerdo - PGP -->
      <div class="left-content">
        <h1 class="pgpp-title">PGP</h1>
        <p class="pgpp-subtitle">
          Plataforma de Gerenciamento<br />
          de Programas de Provimento
        </p>
      </div>

      <!-- Lado direito - Card de login -->
      <div class="right-content">
        <div class="login-card-wrapper">
          <div class="card-shadow-3"></div>
          <div class="card-shadow-2"></div>
          <div class="card-shadow-1"></div>
          <div class="login-card">
            <div
              class="login-tabs"
              role="tablist"
              aria-label="Opções de acesso"
            >
              <button
                type="button"
                class="login-tab"
                role="tab"
                id="tab-pessoa-fisica"
                aria-controls="panel-pessoa-fisica"
                [class.active]="abaLoginAtiva() === 'pessoa-fisica'"
                [attr.aria-selected]="abaLoginAtiva() === 'pessoa-fisica'"
                (click)="selecionarAbaLogin('pessoa-fisica')"
              >
                <i class="fas fa-user" aria-hidden="true"></i>
                <span>Pessoa Física</span>
              </button>

              <button
                type="button"
                class="login-tab ms-1"
                role="tab"
                id="tab-cadastro-gestor"
                aria-controls="panel-cadastro-gestor"
                [class.active]="abaLoginAtiva() === 'cadastro-gestor'"
                [attr.aria-selected]="abaLoginAtiva() === 'cadastro-gestor'"
                (click)="selecionarAbaLogin('cadastro-gestor')"
              >
                <i class="fas fa-city" aria-hidden="true"></i>
                <span>Cadastro de Gestor</span>
              </button>
            </div>

            @if (abaLoginAtiva() === "pessoa-fisica") {
              <div
                class="login-tab-content"
                role="tabpanel"
                id="panel-pessoa-fisica"
                aria-labelledby="tab-pessoa-fisica"
              >
                <h2>Bem vindo (a)!</h2>

                <p>
                  O seu espaço para acompanhar e participar dos programas de
                  provimento do SUS. Acesse com sua conta Gov.br e comece agora.
                </p>

                <app-button
                  [isLoginGovBr]="true"
                  [type]="ButtonType.PRIMARY"
                  [noMargin]="true"
                  (action)="login()"
                ></app-button>
              </div>
            }
            @if (abaLoginAtiva() === "cadastro-gestor") {
              <div>
                <h2>Cadastro de Gestor</h2>

                <p>
                  Solicite seu cadastro como gestor municipal para acessar as
                  funcionalidades destinadas à gestão local dos programas de
                  provimento.
                </p>

                <div class="gestor-link-wrapper">
                  <app-button
                    [type]="ButtonType.SECONDARY"
                    [label]="'Cadastro de Gestor Municipal'"
                    [icon]="'fa-city'"
                    [noMargin]="true"
                    class="gestor-link"
                    (action)="abrirCadastroGestor()"
                  >
                  </app-button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Cards informativos -->
    <div class="info-cards-wrapper">
      <div class="info-cards-container">
        <!-- Card Editais -->
        <div class="info-card card-editais">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h3>Editais</h3>
          </div>
          <p>Acesse os chamamentos públicos do Programa Mais Médicos</p>
          <button
            type="button"
            onclick="
              window.location.href =
                'https://www.gov.br/saude/pt-br/composicao/sgtes/mais-medicos/chamamentos-publicos'
            "
          >
            Acessar editais
          </button>
        </div>

        <!-- Card Título -->
        <div class="info-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h3>Informações do Programa</h3>
          </div>
          <p>Acesse as informações gerais do Programa Mais Médicos</p>
          <button
            type="button"
            onclick="
              window.location.href =
                'https://www.gov.br/saude/pt-br/composicao/sgtes/mais-medicos'
            "
          >
            Acessar
          </button>
        </div>

        <!-- Card Busca de Médico Intercambista (HU059) -->
        <div class="info-card card-busca-intercambista">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h3>Consultar RMS Profissionais</h3>
          </div>
          <p>Consulte RMS Médicos Intercambistas</p>
          <button type="button" (click)="abrirBuscaMedicoIntercambista()">
            Consultar
          </button>
        </div>

        <!-- Card Validação de Declaração de Atuação -->
        <div class="info-card card-validacao-declaracao">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M12 2 4 5v6c0 5.05 3.41 9.77 8 11 4.59-1.23 8-5.95 8-11V5l-8-3Zm-1.1 14.2-3.4-3.4 1.4-1.4 2 2 4.6-4.6 1.4 1.4-6 6Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h3>Validar Declaração de Atuação</h3>
          </div>
          <p>Valide a Declaração de Atuação do Médico</p>
          <button type="button" (click)="abrirValidacaoDeclaracao()">
            Validar
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- Rodapé -->
  <footer class="footer">
    <agsus-footer
      #footer
      id="footer"
      logo-alt="SUS - Agência Brasileira de Apoio à Gestão do SUS"
    >
    </agsus-footer>
  </footer>
</div>
